import { render, staticRenderFns } from "./BoletosPagos.vue?vue&type=template&id=4eb58d74"
import script from "./BoletosPagos.vue?vue&type=script&lang=js"
export * from "./BoletosPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports